import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from '../../helpers/axios';

export const getOrganizationProfileDetailsThunk = createAsyncThunk(
    'admin/organization/details',
    async (payload, thunkAPI) => {
        try {
            const response = await api.patch(
                `admin/organization/details/?page=${payload.page}&page_size=${payload.pageSize}`,
                {
                    email: payload.email
                }
            );

            return response.data;
        } catch(err) {
            return err;
        }
    }
)

export const getOrganizationEmployeesThunk = createAsyncThunk(
    'admin/organization/details',
    async (payload, thunkAPI) => {
        try {
            const response = await api.patch(
                `admin/employee?organization_id=2&search=${payload.search}&page=${payload.page}&page_size=${payload.pageSize}`,
                {
                    email: payload.email
                }
            );

            return response.data;
        } catch(err) {
            return err;
        }
    }
);

const organizationProfileTabSlice = createSlice({
    name: 'OrganizationProfileTab',
    initialState: {
        organizationProfile: {},
        isLoading: false,
        employees: []
    },
    extraReducers: {
        [getOrganizationProfileDetailsThunk.pending]: (state, action) => {
            state.isLoading = true;
        },
        [getOrganizationProfileDetailsThunk.fulfilled]: (state, action) => {
            state.isLoading = false;
            state.organizationProfile = action.payload?.data?.organization_profile;
        },
        [getOrganizationProfileDetailsThunk.rejected]: (state, action) => {
            state.isLoading = false;
        },
    },
    reducers: {
        clearOrganizationProfileTabState: (state) => {
            state.organizationProfile= {};
            state.isLoading= false;
            state.employees= [];
        }
    }
});

export const { clearOrganizationProfileTabState } = organizationProfileTabSlice.actions;

export const organizationProfileTabSelector = (state) => state.organizationProfileTab;

export default organizationProfileTabSlice.reducer; 
